export const allIAMPolicies = (
  departmentId,
  appId = "001",
  environmentId,
  accountNumber = "904433914959",
  regionCode
) => [
  {
    ResourceName: "LSQClearDynamoDBLogs-Policy-v3",
    Provider: "AWS",
    ResourceId: "ANPA6A6SS452A2ISZRTX5",
    Region: regionCode ? regionCode : "us-east-1",
    DepartmentId: departmentId,
    EnvironmentId: environmentId,
    CreatedBy: null,
    ModifiedOn: "2019-10-03 09:22:14",
    ResourceType: "IAMPolicy",
    ResourceTags: [
      {
        Key: "Name",
        Value: "LSQClearDynamoDBLogs-Policy-v3",
      },
    ],
    Domain: "Security",
    AccountNumber: accountNumber ? accountNumber : "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: appId,
    CreatedOn: "2019-10-03 09:19:57",
    ModifiedBy: null,
    ARN: "arn:aws:iam:us-east-1:904433914959:policy:LSQClearDynamoDBLogs-Policy-v3",
  },
  {
    ResourceName: "DynamoDBLogs-Policy-v3",
    Provider: "AWS",
    ResourceId: "ARPA6A66T452Y2ISZRTX5",
    Region: regionCode ? regionCode : "us-east-1",
    DepartmentId: departmentId,
    EnvironmentId: environmentId,
    CreatedBy: null,
    ModifiedOn: "2019-10-03 09:22:14",
    ResourceType: "IAMPolicy",
    ResourceTags: [
      {
        Key: "Name",
        Value: "DynamoDBLogs-Policy-v3",
      },
    ],
    Domain: "Security",
    AccountNumber: accountNumber ? accountNumber : "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: appId,
    CreatedOn: "2019-10-03 09:19:57",
    ModifiedBy: null,
    ARN: "arn:aws:iam:us-east-1:904433914959:policy:DynamoDBLogs-Policy-v3",
  },
];
